var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasTags)?_c('div',{staticClass:"field is-grouped is-grouped-multiline"},_vm._l((_vm.tags),function(value,key){return _c('div',{key:key,staticClass:"control"},[_c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag is-dark",domProps:{"textContent":_vm._s(key)}}),_vm._v(" "),_c('span',{staticClass:"tag is-light",domProps:{"textContent":_vm._s(value)}})])])})):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fc69064","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/sba-tags.vue
// module id = null
// module chunks = 